var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`blog__button ${_vm.color} ${_vm.inverted ? 'inverted' : ''}`,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('span',{staticClass:"loader"},[_c('BCXIcon',{attrs:{"icon":"DotsDots"}})],1):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }